import React from "react"
import Layout from "../../../components/layout"
import { Link } from "gatsby"

export default (props) => (
  <Layout location={props.location}>
    <div className="row">
      <div className="col-md-12">
        <div className="page-header">
          <h1>POST /users/me/cm/subscriptions</h1>
        </div>
        <p>
          Add the current user as a subscriber of <em>Cloud Message (CM)</em>.
          This will allow the user to receive push notifications on the device.
          Note: Include subscriptionId or deviceId in the request body.
        </p>
        <p>
          For information on how to receive <em>Cloud Messages</em> sent to your
          client application, see{" "}
          <a href="https://firebase.google.com/docs/cloud-messaging/">here</a>
        </p>
        <h2>URL Parameters</h2>
        <p>None.</p>
        <h2>Body Parameters</h2>
        <div className="table-responsive">
          <table className="table table-striped table-bordered table-condensed">
            <tbody valign="top">
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>JSON type</th>
                <th>Required</th>
                <th>Default Value</th>
              </tr>
              <tr>
                <td>dataOnly</td>
                <td>
                  Data only messages are not processed as push notifications by
                  device, client app must process message data.
                </td>
                <td>boolean</td>
                <td>No</td>
                <td>false</td>
              </tr>
              <tr>
                <td>subscriptionType</td>
                <td>Currently only 'firebase' supported.</td>
                <td>string</td>
                <td>No</td>
                <td>firebase</td>
              </tr>
              <tr>
                <td>subscriptionId</td>
                <td>Unique identifier of the subscription.</td>
                <td>string</td>
                <td>Only if no deviceId</td>
                <td />
              </tr>
              <tr>
                <td>deviceId</td>
                <td>Unique identifier of the device.</td>
                <td>string</td>
                <td>Only if no subscriptionId</td>
                <td />
              </tr>
              <tr>
                <td>scope</td>
                <td>
                  Category of notifications to subscribe ('group', 'direct',
                  'all').
                </td>
                <td>array</td>
                <td>No</td>
                <td>all</td>
              </tr>
              <tr>
                <td>deviceType</td>
                <td>Type of device ('browser', 'mobile').</td>
                <td>string</td>
                <td>No</td>
                <td />
              </tr>
            </tbody>
          </table>
        </div>
        <h2>Authentication</h2>
        <p>JwtAuthenticator, Oauth2Authenticator, AnonymousAuthenticator</p>
        <h2>Authorization</h2>
        <p>OAuthAuthorizer</p>
        <h2>Example Request</h2>
        <h4>URL</h4>
        <pre className="nginx">
          POST https://spacesapis.avayacloud.com/api/users/me/cm/subscriptions
        </pre>
        <h4>Headers</h4>
        <pre className="javascript">
          Authorization: "jwt
          eyJhbGciOiJSUzI1NiIsIdfgdfgnR5cCI6IkpXVCJ9.eyJ1c2VyX2lkX3NpZyI6ImxPWHpxNzVzR3J3X0xwWEMyRGRMakhyYXJlWVhyTzFMdEZHZkhkOWNkTXciLCJwcm9kdWN0X3R5cGUiOiJhY2NvdW50cyIsImxhc3R1cGRhdGV0aW1lIjoiMjAxNy0wMS0zMFQxMzo1ODo0Ny4yMDYiLCJpc3MiOiJ6YW5nLmlvIiwicHVibGlja2V5aWQiOiJhZ3h6Zm05dVpYTnVZVEl3TVRSeUdnc1NEVWRLZDNSUWRXSnNhV05MWlhrdfgdWdJQ2dsUEtFakFvTSIsImV4cCI6MTQ5NTM5MTIwMywidXNlcl9pZCI6ImFneHpmbTl1WlhOdVlUSXdNVFJ5RVFzU0JGVnpaWElZZ0lEQXMtX25fUW9NIiwidmVyIjoiMi4wIn0.SqZpw1uPIebqW3qlDsm0-DWYFKEH0SgPwtD-tSESWOF-5hLkZMqJH28ooWux2S7s9riIew7pTVPnZpTgJa5zHcEAG0gXSEJVOqmpGp_4ufM8YtZoZMpBFjyAkwyAt-ILkGUYIo0GU5WyzMPLV8YLXfgdfgOgkE2MGGOajBkjPmC2Db3pA0D0M9k-21EL1gwWBC5YIq0PDAkgulegwl6khRmB8irJQ-dfg-d-KV9eYfFpsCdJKRGzSfqg"
        </pre>
        <p>Or</p>
        <pre className="javascript">
          Authorization: "bearer f746696f5de4528u128ae2f274eea253e8a7943a"
        </pre>
        <h4>Example Request Body</h4>
        <pre className="json">
          {"{"}
          {"\n"}
          {"  "}"subscriptionId": "12344444444",{"\n"}
          {"  "}"scope": ["all"]{"\n"}
          {"}"}
          {"\n"}
        </pre>
        <h2>Example Response</h2>
        <pre className="json">
         {`{
    "deviceId": "6d843bf3-ab98-49f5-9d34-23b4822bf05a",
    "dataOnly": false,
    "type": "firebase",
    "scope": [
        "all"
    ],
    "_id": "5ed15bad3e06483dd3848697",
    "subscriptionId": "12344444444",
    "__v": 0,
    "status": "adding",
    "uid": "user_5efc5417aa4a347af96de290",
    "userId": "5efc5417aa4a347af96de290",
    "userType": "user",
    "created": "2020-07-28T14:29:44.024Z",
    "id": "5ed15bad3e06483dd3848697"
}`}
        </pre>
      </div>
    </div>
  </Layout>
)
